import {appComponent} from '../app.component';
import {HelpComponent} from '../help/help.component';

require('./help.scss');

new HelpComponent(appComponent.cmsService);
